import styled from 'styled-components';
import MaxCostChanges from './MaxCostChanges';

export default styled(MaxCostChanges)`
  padding: 0.8rem;
  background-color: var(--grey700);

  .item {
    color: var(--grey300);
    &__time {
      color: var(--grey100);
      margin-right: 1rem;
    }
  }
`;
